import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';
import { IManualEventOverrides } from '@faire/web--source/common/pete/types';

export const eventKey = 'frontend_tooling-performance_breakdown-timing';

/**
 * https:&#x2F;&#x2F;docs.google.com&#x2F;document&#x2F;d&#x2F;1zSjvc-A7CbTDu6FZikarbi-KeNh7yIjIHe_fu3hQLSo&#x2F;edit
 */
export function trackFrontendToolingPerformanceBreakdownTiming(
  Action_Name: string,
  Load_Type2: string,
  Load_Status3: string,
  Data_Fetched4: string,
  Images_Painted5: string,
  Main_JavaScript_Executed6: string,
  Main_Thread_Idle7: string,
  Page_Component_Mounted8: string,
  Page_Component_Rendered_With_Data9: string,
  Page_JavaScript_Executed10: string,
  Ready_to_Fetch_Data11: string,
  Ready_to_Fetch_Page_JavaScript12: string,
  HTML_Started13: string,
  UPLT_end_time14: string,
  NextJS15: string = 'false',
  manualOverrides?: IManualEventOverrides
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: true,
    manualOverrides: manualOverrides,
    parameters: {
      Action_Name,
      Load_Type2,
      Load_Status3,
      Data_Fetched4,
      Images_Painted5,
      Main_JavaScript_Executed6,
      Main_Thread_Idle7,
      Page_Component_Mounted8,
      Page_Component_Rendered_With_Data9,
      Page_JavaScript_Executed10,
      Ready_to_Fetch_Data11,
      Ready_to_Fetch_Page_JavaScript12,
      HTML_Started13,
      UPLT_end_time14,
      NextJS15,
    },
  });
}
